// extracted by mini-css-extract-plugin
export default {"appMenuContainerDesktop":"RootLayout_appMenuContainerDesktop__Xv9i4","appMenuContainerTablet":"RootLayout_appMenuContainerTablet__fv7Y4"};